import moment from "moment";
import loader from "./loader";
// import _ from 'lodash'
import secureStorage from "libs/secureStorage";
import getinfo from "helper/getinfo";

const receipt = (payload) => {
  const printer = secureStorage.getItem("printer");
  const user = secureStorage.getItem("account");
  const info = secureStorage.getItem("domainInfo");
  const title = `${payload.title.padStart(105, " ")}\r\n`;
  const body = payload.body;

  // const totalPayment = body.filter((item,index)=>index >= body.length-4 && index < body.length-1 )
  const leftPage = [
    ["TGL", moment(body.date.value).format("DD/MM/YY HH:mm")],
    ["NO VA", body.vaNo.value],
    [body.name.caption, body.name.value],
    ["BLN", body.month.value],
    ["PREMI", body.premiumFee.value],
    ["RP TAG", body.amount.value],
    ["ADMIN", body.admin.value],
    ["BAYAR", body.total.value]
  ];

  for (let i = leftPage.length; i < 11; i++) leftPage.push([""]);
  const branchNo = body.branchCode || body.branchNo;
  const branch = body.branch || body.branchName;
  const middlePage = [
    ["TANGGAL", moment(body.date.value).format("DD/MM/YY HH:mm")],
    ["NO VA", body.vaNo.value],
    [body.name.caption, body.name.value],
    ["BLN", body.month.value],
    ["NOCABANG", branchNo.value],
    [branch.caption, branch.value],

    ...getinfo(body.info.value),
  ];

  printer === "dotmatrix"
    ? middlePage.push([`${String.fromCharCode(27)}4Loket : ${user.name}`])
    : middlePage.push([`Loket : ${user.name}`]);
  printer === "dotmatrix"
    ? middlePage.push([
      `Powered by ${payload.appName}${String.fromCharCode(27)}5`,
    ])
    : middlePage.push([`Powered by ${payload.appName}`]);

  for (let i = middlePage.length; i < 11; i++) middlePage.push([""]);
  // console.log(middlePage)
  const rightPage = [
    ["PREMI", body.premiumFee.value],
    ["TUNGGAKAN", body.outstandingAmount.value],
    [body.amount.caption, body.amount.value],
    [body.admin.caption, body.admin.value],
    [body.total.caption, body.total.value],
  ];
  for (let i = rightPage.length; i < 11; i++) rightPage.push([""]);

  if (printer === "dotmatrix")
    return loader(title, leftPage, middlePage, rightPage, payload);
  else return { title, leftPage, middlePage, rightPage, payload };
};
export default receipt;
